const singleSimPageType = {
  START_FETCHING_SINGLE_SIM_PAGE: "START_FETCHING_SINGLE_SIM_PAGE",
  SUCCESS_FETCHIED_SINGLE_SIM_PAGE: "SUCCESS_FETCHIED_SINGLE_SIM_PAGE",
  FAILURE_FETCHED_SINGLE_SIM_PAGE: "FAILURE_FETCHED_SINGLE_SIM_PAGE",
};

export default singleSimPageType;
